import { z } from 'zod';
import { arrayValidator, discriminatedUnionValidator, encryptedKeyByRsaKeyValidator, MemberRole, nullValidator, uuidValidator, } from '#validation';
const MemberRoleUpdateOwnerSchema = z.object({
    role: z.literal(MemberRole.OWNER),
});
const MemberRoleUpdateAdminSchema = z.object({
    role: z.literal(MemberRole.ADMIN),
    eAdminPrivateKeyByMemberKey: encryptedKeyByRsaKeyValidator,
});
const MemberRoleUpdateCollaboratorSchema = z.object({
    role: z.literal(MemberRole.COLLABORATOR),
    eAdminPrivateKeyByMemberKey: nullValidator({
        error: 'member.collaborator.adminKey.null',
    }),
});
const MemberRoleUpdateFilespaceAdminSchema = z.object({
    role: z.literal(MemberRole.FILESPACE_ADMIN),
    eAdminPrivateKeyByMemberKey: encryptedKeyByRsaKeyValidator,
    filespaceIds: arrayValidator({
        element: uuidValidator({
            requiredError: 'member.filespaceAdmin.filespaceId.required',
            formatError: 'member.filespaceAdmin.filespaceId.format',
        }),
        requiredError: 'member.filespaceAdmin.filespaceId.required',
    }),
});
export const MemberRoleUpdateSchema = discriminatedUnionValidator({
    discriminator: 'role',
    schemas: [
        MemberRoleUpdateOwnerSchema,
        MemberRoleUpdateAdminSchema,
        MemberRoleUpdateCollaboratorSchema,
        MemberRoleUpdateFilespaceAdminSchema,
    ],
    requiredError: 'member.role.required',
    invalidValueError: 'member.role.invalid',
});
